module.exports = __webpack_public_path__ + "static/media/1013224.7661dd42.png";